'use strict';

var React = require('react');

const DEFAULT_CONTEXT_VALUE = {
    isMobile: false,
    isTablet: false,
};
const DeviceContext = React.createContext(DEFAULT_CONTEXT_VALUE);

exports.DeviceContext = DeviceContext;
//# sourceMappingURL=DeviceContext-f99d280d.js.map
